<template>
    <section style="margin:18px;">
        <v-btn @click="OpenDialog">Add Job Listing</v-btn>
        <v-btn @click="OpenSEODialog">Add Job Listing SEO</v-btn>
        <app-add-job-listing ref="addjoblisting" :dialog='AddJobListing' @close='CloseDialog'></app-add-job-listing>
        <app-add-job-seo ref="addjobseo" :dialog='AddJobListingSEO' @close='CloseDialog'></app-add-job-seo>
        <app-listing-table></app-listing-table>
    </section>
</template>
<script>

import appAddJobListing from '../views/dialogs/AddJobsListing'
import appListingTable  from '../views/tables/JobListingTable'
import appAddJobSeo     from '../views/dialogs/AddJobSEO'

export default {
    components:{
        appAddJobListing,
        appListingTable,
        appAddJobSeo
    },
    data(){
        return {
            AddJobListing : false,
            AddJobListingSEO : false
        }
    },
    methods:{
        OpenDialog(){

            this.$refs.addjoblisting.GetJobCategoryList()
            this.AddJobListing = true

        },
        CloseDialog(){

            this.AddJobListing = false
            this.AddJobListingSEO = false
        },
        OpenSEODialog(){

            this.$refs.addjobseo.GetJobsList()
            this.AddJobListingSEO = true
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }   
}
</script>
<style>

</style>
